import React from 'react'
import { Radio, Flex } from 'antd'
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom'

export const VisualAidGlobalSearchSwitch = () => {
  const history = useHistory()

  const matchGlobalSearch = useRouteMatch({
    path: '/global-search/vin/:vin',
    exact: true,
  })
  const matchVisualAid = useRouteMatch({
    path: '/global-search/vin/:vin/visual-aid',
    exact: true,
  })
  const vin = matchVisualAid?.params.vin || matchGlobalSearch?.params.vin

  const value = matchVisualAid ? 'visual-aid' : 'global-search'

  const onChange = (e) => {
    const next = e.target.value
    if (next === 'visual-aid') {
      history.push(`/global-search/vin/${vin}/visual-aid`)
    } else {
      history.push(`/global-search/vin/${vin}`)
    }
  }

  return (
    <Flex
      gap="small"
      align="center"
      justify="center"
      buttonStyle="solid"
      size="middle"
    >
      <div>
        <Radio.Group onChange={onChange} value={value} buttonStyle="solid">
          <Radio.Button value="global-search">Global Search</Radio.Button>
          <Radio.Button value="visual-aid">Visual Aid</Radio.Button>
        </Radio.Group>
      </div>
    </Flex>
  )
}
